import request from "@/utils/request";

// export function getAll() {
//   return request({
//     url: "/base/salesDepartments/getAll",
//     method: "get",
//   });
// }

export function getPage(condition, pagination) {
  return request({
    url: "/base/base/page",
    method: "post",
    data: { condition: condition, pagination: pagination },
  });
}

export function saveOrUpdate(data) {
  return request({
    url: "/base/base/saveOrUpdate",
    method: "post",
    data,
  });
}

export function get(id) {
  return request({
    url: "/base/base/get",
    method: "get",
    params: { id },
  });
}

export function deleteById(id) {
  return request({
    url: "/base/base/deleteById",
    method: "post",
    data: { id: id },
  });
}

// export function deleteBatchByIds(ids) {
//   return request({
//     url: "/base/salesDepartments/deleteBatchById",
//     method: "post",
//     data: { ids: ids },
//   });
// }

export function exportExcel(condition, pagination) {
  return request({
    url: "/base/base/exportExcel",
    method: "post",
    data: { condition: condition, pagination: pagination },
    responseType: "blob",
  });
}
export function getBusinessType(condition, pagination) {
  return request({
    url: "/base/salesDepartments/pageList",
    method: "post",
    data: { condition: condition, pagination: pagination },
  });
}